export default {
  // 首頁類型
  TYPE_HOME: 'home', // 首頁
  TYPE_NEWS: 'news', // 新聞
  TYPE_DRAMA: 'drama', // 戲劇
  TYPE_CHILDREN: 'children', // 兒童
  TYPE_PROGRAM: 'program', // 節目
  TYPE_APP: 'app', // app

  // 版型
  LAYOUT_A: 'A', // 版型A
  LAYOUT_B: 'B', // 版型B
  LAYOUT_C: 'C', // 版型C
  LAYOUT_D: 'D', // 版型D
  LAYOUT_E: 'E', // 版型E
  LAYOUT_F: 'F', // 版型F
  LAYOUT_G: 'G', // 版型G
  LAYOUT_H: 'H', // 版型H
  LAYOUT_I: 'I', // 版型I
  LAYOUT_J: 'J', // 版型J
  LAYOUT_K: 'K', // 版型K
  LAYOUT_L: 'L', // 版型L(主播介紹)

  // 策展元件類型
  SHOWCASE_ITEM_TYPE_SERIES: 'series', // 影集
  SHOWCASE_ITEM_TYPE_PHOTO: 'showcase-photo', // 圖片
  SHOWCASE_ITEM_TYPE_NEWS: 'news', // 新聞
  SHOWCASE_ITEM_TYPE_ARTICLE: 'article', // 文章
  SHOWCASE_ITEM_TYPE_POST: 'post', // 公告(最新消息)
  SHOWCASE_ITEM_TYPE_EP: 'ep', // 分集
  SHOWCASE_ITEM_TYPE_VIDEO: 'video', // 影片

  // 策展類型
  SHOWCASE_TYPE_NORMAL: 'normal', // 一般
  SHOWCASE_TYPE_ACCENT: 'accent', // 腔調
  SHOWCASE_TYPE_TYPE: 'type', // 型別

  // 策展子類型(兒少頁)
  SUBTYPE_CHILDREN: 'children', // 兒童
  SUBTYPE_TEENS: 'teens', // 青少年
  SUBTYPE_ANIMATION: 'animation', // 動畫
}
